import { useReducer } from 'react';
import { IMmv } from './types';
import { ACTIONS } from './actions';
import { fetchMmvData } from './api';

export const useMmvData = () => {
    const [state, dispatch] = useReducer(reducer, {
        isFetching: null,
        isSuccess: null,
        isError: null,
        mmvData: {},
    });

    const getMmvData = async ({ vehicle_type }) => {
        try {
            const data = await fetchMmvData({ vehicle_type });
            dispatch({
                type: ACTIONS.SET_MMV_DATA,
                payload: data?.result,
            });
        } catch (e) {
            console.log(e);
        }
    };

    function reducer(state: IMmv, action) {
        if (action.type === ACTIONS.GET_MMV_DATA) {
            getMmvData({ vehicle_type: action?.payload?.vehicle_type });
            return {
                ...state,
                isFetching: true,
            };
        }
        if (action.type === ACTIONS.SET_MMV_DATA) {
            return {
                ...state,
                isFetching: false,
                isSuccess: true,
                mmvData: {
                    ...action.payload,
                },
            };
        }
        return {
            ...state,
        };
    }

    return {
        mmvStore: state!,
        dispatch,
    };
};
